import { SelectOption } from '@web-for-marketing/react-ui';

const europeanCountryOptions: SelectOption[] = [
    { value: 'AL', content: 'Albania' },
    { value: 'AD', content: 'Andorra' },
    { value: 'AM', content: 'Armenia' },
    { value: 'AT', content: 'Austria' },
    { value: 'AZ', content: 'Azerbaijan' },
    { value: 'BY', content: 'Belarus' },
    { value: 'BE', content: 'Belgium' },
    { value: 'BA', content: 'Bosnia and Herzegovina' },
    { value: 'BG', content: 'Bulgaria' },
    { value: 'HR', content: 'Croatia' },
    { value: 'CY', content: 'Cyprus' },
    { value: 'CZ', content: 'Czech Republic' },
    { value: 'DK', content: 'Denmark' },
    { value: 'EE', content: 'Estonia' },
    { value: 'FI', content: 'Finland' },
    { value: 'FR', content: 'France' },
    { value: 'GE', content: 'Georgia' },
    { value: 'DE', content: 'Germany' },
    { value: 'GR', content: 'Greece' },
    { value: 'HU', content: 'Hungary' },
    { value: 'IS', content: 'Iceland' },
    { value: 'IE', content: 'Ireland' },
    { value: 'IT', content: 'Italy' },
    { value: 'KZ', content: 'Kazakhstan' },
    { value: 'LV', content: 'Latvia' },
    { value: 'LI', content: 'Liechtenstein' },
    { value: 'LT', content: 'Lithuania' },
    { value: 'LU', content: 'Luxembourg' },
    { value: 'MK', content: 'Macedonia, the former Yugoslav Republic of' },
    { value: 'MT', content: 'Malta' },
    { value: 'MD', content: 'Moldova, Republic of' },
    { value: 'MC', content: 'Monaco' },
    { value: 'ME', content: 'Montenegro' },
    { value: 'NL', content: 'Netherlands' },
    { value: 'NO', content: 'Norway' },
    { value: 'PL', content: 'Poland' },
    { value: 'PT', content: 'Portugal' },
    { value: 'RO', content: 'Romania' },
    { value: 'RU', content: 'Russian Federation' },
    { value: 'SM', content: 'San Marino' },
    { value: 'RS', content: 'Serbia' },
    { value: 'SK', content: 'Slovakia' },
    { value: 'SI', content: 'Slovenia' },
    { value: 'ES', content: 'Spain' },
    { value: 'SE', content: 'Sweden' },
    { value: 'CH', content: 'Switzerland' },
    { value: 'TR', content: 'Turkey' },
    { value: 'UA', content: 'Ukraine' },
    { value: 'GB', content: 'United Kingdom' },
    { value: 'VA', content: 'Holy See (Vatican City State)' },
];

export default europeanCountryOptions;
